// Fotos y actividad de la obra para cruzar con el clima. Usa lo que ya existe:
//  - última foto: webback /api/s3-images/:feed/latest (con login) y, si no, la última foto analizada por la IA
//  - fotos de un día y personas por día: las detecciones del Dashboard IA (iaData.loadDays, con caché IndexedDB)
// Nunca le pide una foto a la cámara (las 4G no se despiertan): solo lee lo que la cámara ya subió.
import { getLatestImage } from '../../../api/lastImage.api';
import { loadDays, photoUrl, periodKpis, DEFAULT_CFG, addDays, todayKey, listDays, isPerson } from '../../IADashboard/iaData';

const sinZonas = { zonas: null };

export async function ultimaFoto(user) {
  if (user?.feedID && localStorage.getItem('authLisualToken')) {
    try {
      const u = await getLatestImage(user.feedID);
      const url = typeof u === 'string' ? u : u?.url;
      if (url) return { url, ms: u?.date ? Date.parse(u.date) : null, fuente: 'camara' };
    } catch (e) { /* sigue con la IA */ }
  }
  return ultimaFotoIA(user);
}

/** La última foto analizada por la IA (ayer y hoy), o null. Para cámaras sin la API de última foto. */
export async function ultimaFotoIA(user) {
  if (!user?.identifier || !user?.customerId) return null;
  const hoy = todayKey();
  const fotos = await loadDays(user.identifier, user.customerId, [addDays(hoy, -1), hoy], null, sinZonas);
  const p = fotos[fotos.length - 1];
  if (!p) return null;
  return { url: await photoUrl(p), ms: p.ms, fuente: 'ia', photo: p };
}

/** La foto del día más cercana a una hora (0-23, hora de la obra). */
export async function fotoDelDia(user, fecha, hora) {
  if (!user?.identifier || !user?.customerId) return null;
  const fotos = await loadDays(user.identifier, user.customerId, [fecha], null, sinZonas);
  if (!fotos.length) return null;
  const objetivo = Date.parse(`${fecha}T${String(hora).padStart(2, '0')}:00:00Z`) + 3 * 3600e3;
  const p = fotos.reduce((a, x) => (Math.abs(x.ms - objetivo) < Math.abs(a.ms - objetivo) ? x : a));
  return { url: await photoUrl(p), ms: p.ms, photo: p };
}

/** Fotos de referencia (mismas horas, otros días) para la señal experimental de lente mojada. */
export async function fotosReferencia(user, fecha, hora, n = 5) {
  if (!user?.identifier || !user?.customerId) return [];
  const dias = [1, 2, 3, 4, 5, 6, 7].map((k) => addDays(fecha, -k));
  const fotos = await loadDays(user.identifier, user.customerId, dias, null, sinZonas);
  const porDia = new Map();
  fotos.forEach((p) => {
    const h = new Date(p.ms - 3 * 3600e3).getUTCHours();
    if (Math.abs(h - hora) > 1) return;
    const k = new Date(p.ms - 3 * 3600e3).toISOString().slice(0, 10);
    if (!porDia.has(k)) porDia.set(k, p);
  });
  return [...porDia.values()].slice(0, n);
}

/**
 * Personas por día según la IA (pico y horas-hombre) en un rango. onProgress(hechos, total).
 * Devuelve null si la cámara no tiene IA (ninguna foto analizada en el rango).
 */
export async function actividadPorDia(user, desde, hasta, onProgress) {
  if (!user?.identifier || !user?.customerId) return null;
  const hoy = todayKey();
  const fin = hasta > hoy ? hoy : hasta;
  if (fin < desde) return null;
  const fotos = await loadDays(user.identifier, user.customerId, listDays(desde, fin), onProgress, sinZonas);
  if (!fotos.length) return null;
  const k = periodKpis(fotos, { ...DEFAULT_CFG, onlyWork: true });
  const out = new Map();
  k.porDia.forEach((d, fecha) => out.set(fecha, { pico: d.peak, horasHombre: d.hh, promedio: d.n ? d.persons / d.n : 0, fotos: d.n, trabajo: d.first != null }));
  return out;
}

export { isPerson };
